module.exports = __webpack_public_path__ + "img/earn-back.b7e503ed.svg";